import Link from "next/link";
import Layout from "../components/Layout";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ],
  }
  ```
*/
export default function Terms() {
  return (
    <>
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/terminos-y-condiciones`}
        title="Términos y condiciones de uso"
        siteTitle="Movi Autos"
      />
      <div className="relative py-16 bg-white overflow-hidden">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div
            className="relative h-full text-lg max-w-prose mx-auto"
            aria-hidden="true"
          >
            <svg
              className="absolute top-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
              />
            </svg>
            <svg
              className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
              />
            </svg>
            <svg
              className="absolute bottom-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="d3eb07ae-5182-43e6-857d-35c643af9034"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
              />
            </svg>
          </div>
        </div>
        <div className="relative px-4">
          <div className="text-lg max-w-prose mx-auto">
            <h1>
              <span className="block text-base text-center text-orange-600 font-semibold tracking-wide uppercase"></span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Terminos y condiciones de uso
              </span>
            </h1>
          </div>
          <div className="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
            <p className="mt-8 text-xl text-gray-500 leading-8">
              Bienvenido al sitio web moviautos.com (el &quot;Sitio&quot;). El
              acceso y uso del Sitio está sujeto a los siguientes términos y
              condiciones (los &quot;Términos&quot;). Al acceder y utilizar el
              Sitio, usted acepta estar sujeto a estos Términos. Si no está de
              acuerdo con estos Términos, no deberá utilizar el Sitio.
            </p>
            <p>
              El Sitio es una plataforma en línea donde las personas y los
              negocios pueden registrarse y publicar automóviles para la venta.
              El Sitio también permite a los usuarios pagar por destacar sus
              publicaciones para aumentar su visibilidad. El Sitio utiliza un
              sistema de pagos de terceros llamado GreenPay. El Sitio no guarda
              la información de tarjeta de crédito de ningún usuario.
            </p>
            <p>
              El Sitio tiene un proceso automatizado de verificación de
              identidad que informa a otros usuarios si un vendedor ha
              verificado o no su identidad. Sin embargo, el Sitio no se hace
              responsable de ninguna estafa que ocurra en relación con una
              compra o venta realizada a través del Sitio, ya que es imposible
              evitar las estafas al 100%.
            </p>
            <p>
              Toda comunicación y negociación se realiza fuera del Sitio por lo
              que no está en nuestro control cualquier situación que suceda que
              pueda llegar a afectar a alguna de las partes involucradas.
            </p>
            <p>
              Para poder acceder a la información de contacto de un vendedor, es
              necesario estar registrado en la aplicación pero no es obligatorio
              verificar su identidad, aún así, el vendedor puede solicitar su
              nombre de usuario en cualquier momento para verificar la
              información.
            </p>
            <p>
              Cualquier persona registrada que obtenga la información de
              contacto de algún vendedor podrá compartir esa información con
              terceros fuera del Sitio, situación sobre la que el Sitio no tiene
              ningún control. Como medida, siempre sugerimos a los vendedores
              verificar la información del interesado, buscando por el nombre de
              usuario dentro del Sitio.
            </p>
            {/* <ul role="list">
            <li>Quis elit egestas venenatis mattis dignissim.</li>
            <li>
              Cras cras lobortis vitae vivamus ultricies facilisis tempus.
            </li>
            <li>Orci in sit morbi dignissim metus diam arcu pretium.</li>
          </ul> */}
            <p>
              Al utilizar el Sitio, acepta que el Sitio puede requerir que
              proporcione información personal, incluyendo una fotografía de su
              cara y una fotografía de su cara junto a su documento de identidad
              o cédula, para el proceso de verificación de identidad. Estas
              fotografías no serán accesibles públicamente.
            </p>
            <p>
              No está permitido el uso de web scrappers para extraer información
              del sitio web, ya sea información pública o privada.
            </p>

            <p>
              Usted se compromete a no utilizar el Sitio para ningún propósito
              ilegal o no autorizado.
            </p>
            <p>
              Usted acepta no interferir con o interrumpir el funcionamiento del
              Sitio.
            </p>
            <p>
              El Sitio se reserva el derecho de modificar o descontinuar el
              Servicio con o sin previo aviso.
            </p>
            <p>
              Las tarifas de cualquier servicio o producto a la venta en el
              sitio pueden cambiar en cualquier momento.
            </p>
            <p>
              El sitio se reserva el derecho de desactivar o borrar cualquier
              cuenta de usuario o publicaciones realizadas por cualquier
              usuario.
            </p>
            <p>
              Si tiene preguntas sobre los terminos de uso, póngase en contacto
              con nosotros a través de nuestro correo electrónico{" "}
              <a href="mailto:contacto@moviautos.com">contacto@moviautos.com</a>{" "}
              o número de teléfono proporcionados en nuestro sitio web.
            </p>
            <p>
              Consultar la <Link href="privacy">Política de Privacidad</Link>.
            </p>
            {/* <blockquote>
            <p>
              Sagittis scelerisque nulla cursus in enim consectetur quam. Dictum
              urna sed consectetur neque tristique pellentesque. Blandit amet,
              sed aenean erat arcu morbi.
            </p>
          </blockquote>
          <p>
            Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
            enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
            praesent donec est. Odio penatibus risus viverra tellus varius sit
            neque erat velit.
          </p> */}
            {/* <figure>
            <img
              className="w-full rounded-lg"
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&w=1310&h=873&q=80&facepad=3"
              alt=""
              width={1310}
              height={873}
            />
            <figcaption>
              Sagittis scelerisque nulla cursus in enim consectetur quam.
            </figcaption>
          </figure>
          <h2>Everything you need to get up and running</h2>
          <p>
            Purus morbi dignissim senectus mattis <a href="#">adipiscing</a>.
            Amet, massa quam varius orci dapibus volutpat cras. In amet eu
            ridiculus leo sodales cursus tristique. Tincidunt sed tempus ut
            viverra ridiculus non molestie. Gravida quis fringilla amet eget dui
            tempor dignissim. Facilisis auctor venenatis varius nunc, congue
            erat ac. Cras fermentum convallis quam.
          </p>
          <p>
            Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
            enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
            praesent donec est. Odio penatibus risus viverra tellus varius sit
            neque erat velit.
          </p> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

// Terms.getLayout = function getLayout(page) {
//   return <Layout>{page}</Layout>;
// };
